<template lang="pug">
    div.width-100-percent.height-100-percent.brown.lighten-5
        CurrentCampaignCustomer(
            v-if="!sharedLinkMode && (validCurrentCampaignCustomer || isCallWithoutCustomer)"
            :current-campaign-customer="currentCampaignCustomer"
            :is-barge="isBarge"
            :is-call-without-customer="isCallWithoutCustomer"
            :is-coach="isCoach"
            :is-listen="isListen"
            :is-live-dash-inbound-call="isLiveDashInboundCall"
            :current-call="currentCall"
            :current-web-rtc-participant="currentWebRtcParticipant"
            :current-web-rtc-session="currentWebRtcSession"
            :exit-current-campaign-customer="exitCurrentCampaignCustomer"
        )
        template(v-else)
            v-banner(single-line icon="mdi-sync" color="var(--white)")
                .volie-color-blue.font-weight-bold Live Dashboard
                template(v-slot:actions)
                    div.d-flex.align-center
                        template(v-if="currentTab === 'overview-tab'")
                            v-autocomplete(
                                v-model='scopedTeamId'
                                :items='dataBank.r_teams'
                                :item-text='DataBank.getItemText("teams")'
                                :item-value='DataBank.getItemValue("teams")'
                                :loading='dataBank.r_teamsIsLoading'
                                label='Select Team'
                                clearable
                                dense
                                outlined
                                hide-details
                                style="min-width: 200px; margin-right: 16px;"
                            )
                        template(v-if="!sharedLinkMode")
                            v-breadcrumbs(:items='breadcrumbItems')
                                template(v-slot:item='{ item }')
                                    div(style="font-size: 14px;")
                                        template(v-if="item.to")
                                            router-link.no-text-underline(:to="item.to") {{ item.text }}
                                        template(v-else) 
                                            | {{ item.text }}
                                template(v-slot:divider)
                                    v-icon mdi-chevron-right

            //- TODO - Just make a component for this and reuse it in agents tab
            //- div.d-flex.justify-end.pr-5.pt-2(v-if="currentTab === 'overview-tab'") 
            //-     v-dialog(v-model='filterDialog' persistent max-width='500')
            //-         template(v-slot:activator='{ on, attrs }')
            //-             v-btn.btn-margin-xs(color="primary" icon small v-bind='attrs' v-on='on')
            //-                 v-icon mdi-filter

            //-         v-card
            //-             v-card-title.headline
            //-                 | Filter
            //-             v-card-text
            //-                 v-container
            //-                     v-row
            //-                         v-col.mb-0.pb-0(cols='12')
            //-                             v-autocomplete(v-model='tmpFilterObj.teamIds' multiple :items='teams' label='Team' item-text="name" item-value="team_id" clearable)
            //-                                 template(v-slot:selection='{ item, index }')
            //-                                     v-chip
            //-                                         span {{ item.name }}

            //-                     v-row
            //-                         v-col.mb-0.pb-0(cols='12')
            //-                             v-checkbox(v-model='tmpFilterObj.makeDefaultFilter' label='Make this my default Overview Tab filter')

            //-             v-card-actions
            //-                 v-spacer
            //-                 v-btn(color='var(--volie-blue)' outlined ripple text @click='closeFilter();')
            //-                     v-icon mdi-close
            //-                     | Close
            //-                 v-btn(color='var(--volie-blue)' outlined ripple text @click='resetFilter();')
            //-                     v-icon mdi-refresh
            //-                     | Reset
            //-                 v-btn(color='green' outlined ripple text @click='submitFilter();')
            //-                     v-icon mdi-filter
            //-                     | Filter
                                    
            div(v-bind:class="[paddingTopClass]")
                v-speed-dial(v-if="!sharedLinkMode" v-model='fab' top left direction='right' style="margin-top: 25px;" absolute open-on-hover transition='slide-y-reverse-transition')
                    template(v-slot:activator)
                        v-btn(v-model='fab' color='amber darken-3' dark fab small)
                            v-icon(v-if='fab')
                                | mdi-close
                            v-icon(v-else)
                                | mdi-swap-horizontal
                    v-btn(fab dark small color='blue' @click="currentTab = 'overview-tab';")  
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-view-dashboard
                            span
                                | Overview

                    v-btn(fab dark small color='blue' @click="currentTab = 'agents-tab';")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-account-group
                            span
                                | Agents

                    v-btn(fab dark small color='blue' @click="currentTab = 'calls-tab';")
                        v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        v-icon mdi-phone
                                span
                                    | Calls

                    v-btn(fab dark small color='blue' @click="currentTab = 'message-dashboard-tab';")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-cellphone-information
                            span
                                | Message Dashboard

                    v-btn(fab dark small color='blue' @click="currentTab = 'vmessage-tab';")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-cellphone
                            span
                                | vMessage

                    v-btn(fab dark small color='blue' @click="currentTab = 'goals-tab';" v-if="goalsEnabled")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-trophy
                            span
                                | Goals

                    v-btn(fab dark small color='blue' @click="$refs.sharedLinkDialog.dialog = true")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    v-icon mdi-export-variant
                            span
                                | Shared Link


            template
                AgentsTab(
                    v-if="currentTab === 'agents-tab' && !sharedLinkMode"
                    :agents="agents"
                    :set-filter-obj="setFilterObj"
                    :teams="teams"
                )
                CallsTab(
                    v-else-if="currentTab === 'calls-tab' && !sharedLinkMode"
                    :agents="agents"
                    :calls-waiting="callsWaiting"
                    :current-base-dashboard-summary="currentBaseDashboardSummary"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :hourly-dashboard-summaries="hourlyDashboardSummaries"
                    :organization-users="organizationUsers"
                    :set-as-call-without-customer="setAsCallWithoutCustomer"
                    :set-current-call="setCurrentCall"
                    :set-current-campaign-customer="setCurrentCampaignCustomer"
                    :set-current-web-rtc-participant="setCurrentWebRtcParticipant"
                    :set-current-web-rtc-session="setCurrentWebRtcSession"
                    :set-supervisor-role="setSupervisorRole"
                )
                MessageDashboardTab(
                    v-else-if="currentTab === 'message-dashboard-tab' && !sharedLinkMode"
                    :agents="agents"
                    :current-base-dashboard-summary="currentBaseDashboardSummary"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :dashboard-summary-conversation-groups="dashboardSummaryConversationGroups"
                    :hourly-dashboard-summaries="hourlyDashboardSummaries"
                    :set-current-campaign-customer="setCurrentCampaignCustomer"
                )
                MessageScreenTab(
                    v-else-if="currentTab === 'message-screen-tab' && !sharedLinkMode"
                    :agents="agents"
                    :current-base-dashboard-summary="currentBaseDashboardSummary"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :set-current-campaign-customer="setCurrentCampaignCustomer"
                )
                OverviewTab(
                    v-else-if="currentTab === 'overview-tab'"
                    :agents="scopedTeamId > 0 ? (scopedTeamAgents || []) : agents"
                    :calls-waiting="scopedTeamId > 0 ? (scopedTeamCallsWaiting || []) : callsWaiting"
                    :current-base-dashboard-summary="currentBaseDashboardSummary"
                    :current-day-dashboard-summary="currentDayDashboardSummary"
                    :current-user="currentUser"
                    :filter-obj="filterObj"
                    :hourly-dashboard-summaries="hourlyDashboardSummaries"
                    :live-dashboard-inbound-calls-enabled="liveDashboardInboundCallsEnabled"
                    :set-as-call-without-customer="setAsCallWithoutCustomer"
                    :set-current-call="setCurrentCall"
                    :set-current-campaign-customer="setCurrentCampaignCustomer"
                    :set-current-web-rtc-participant="setCurrentWebRtcParticipant"
                    :set-current-web-rtc-session="setCurrentWebRtcSession"
                    :set-supervisor-role="setSupervisorRole"
                    :team-scope-empty-message="teamScopeEmptyMessage"
                    :team-scope-loading="scopedTeamDataLoading"
                    :teams="teams"
                )
                Goals(
                    v-else-if="currentTab === 'goals-tab' && !sharedLinkMode"
                    :goals-by-recurring-type-for-today="goals"
                )
                VMessage(
                    v-show="currentTab === 'vmessage-tab' && !sharedLinkMode"
                    :current-navigation="currentNavigation"
                    source="live_dashboard"
                )

            SharedLinksDialog(
                v-if="!sharedLinkMode"
                ref="sharedLinkDialog"
                :account-id="currentUser.activated_account_id"
                component="live_dashboard"
                :shareable-id="currentUser.activated_account_id"
                shareable-type="account"
                :auto-create="true"
            )


</template>

<!--

Agent buckets
-------------

1. General

    - Agents Online
    - Agents Idle
    - % time today on inbound calls
    - % time today on outbound calls
    - % time today on messages
    - % time today other

2. Phone

    - Agents on calls
    - Agents in wrap up
    - Calls holding
    - Current longest hold duration
    - Average hold duration
    - Dropped calls

3. Message

    - Agents handling conversation
    - Unanswered messages
    - Longest waiting message duration
    - Unassigned conversations

-->

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import AgentsTab from '@/components/dashboards/live/tabs/agents.vue';
    import CallsTab from '@/components/dashboards/live/tabs/calls.vue';
    import CurrentCampaignCustomer from '@/components/dashboards/live/current_campaign_customer.vue';
    import Goals from '@/components/dashboards/live/tabs/goals/main.vue';
    import MessageDashboardTab from '@/components/dashboards/live/message_dashboard.vue';
    import MessageScreenTab from '@/components/dashboards/live/tabs/messages.vue';
    import OverviewTab from '@/components/dashboards/live/tabs/overview.vue';
    import SharedLinksDialog from '@/components/shared_links/dialog.vue';
    import VMessage from '@/components/communication_center/vmessage.vue';

    // Data
    import { GetBaseDashboardSummaries, GetCallsWaiting, GetGoals, GetLiveDashboardAgents, GetCurrentBaseDashboardSummaryForSharedLink, GetOrganizationUsers, GetTeams, MatchOrCreateBaseDashboardSummary } from "@/data";

    // Helpers
    import { getCookie, setCookie } from '@/helpers/cookie';

    export default Vue.extend({
        beforeCreate() {
            return new DataBank({
                lazyResources: ['teams'],
            });
        },
        data() {
            return {
                DataBank,
                agents: [],
                breadcrumbItems: [
                    {
                        text: 'Home',
                        link: true,
                        to: { name: 'root' },
                    },
                    {
                        text: 'Live Dashboard',
                        ripple: true,
                    },
                ],
                bus: VolieState.websocketClient().eventBus(),
                callsWaiting: [],
                callsWaitingEpoch: 0,
                callsWaitingPollInterval: null,
                clockInterval: null,
                currentCall: null,
                currentCampaignCustomer: null,
                currentWebRtcParticipant: null,
                currentWebRtcSession: null,
                currentTab: "overview-tab",
                fab: false,
                filterDialog: false,
                filterObj: null,
                goalsEnabled: false,
                goals: {},
                isBarge: false,
                isCallWithoutCustomer: false,
                isCoach: false,
                isListen: false,
                isLiveDashInboundCall: false,
                liveDashboardInboundCallsEnabled: false,
                organizationUsers: [],
                scopedTeamId: null,
                scopedTeamAgents: null,
                scopedTeamCallsWaiting: null,
                scopedTeamDataLoading: false,
                summaryPollInterval: null,
                teams: [],
                tmpFilterObj: null,
            }
        },
        methods: {
            closeFilter() {
                this.tmpFilterObj = { ...this.filterObj }; // Set tmp back to main filter so when they open the dialog again it matches what the page says
                this.filterDialog = false;
            },
            exitCurrentCampaignCustomer() {
                // reset barge/listen
                if (this.isBarge || this.isListen || this.isCoach) {
                    this.isBarge = false;
                    this.isListen = false;
                    this.isCoach = false;
                    this.isLiveDashInboundCall = false;
                }

                this.currentCampaignCustomer = null;
                this.isCallWithoutCustomer = false;
                this.setHtmlOverflow('scroll');
            },
            getAccountGoalsForToday() {
                const options = {
                    ownable_id: this.currentUser.activated_account_id,
                    ownable_type: "account",
                }

                this.isLoading = true;

                GetGoals(options).then((response) => {
                    if (response?.Data) {
                        this.goalsEnabled = response.Data.goals_enabled;
                        if (response?.Data?.goals?.length > 0) {
                            this.goals = this.splitGoalsByRecurringType(response.Data.goals);
                        }
                    }

                    this.isLoading = false;
                });
            },
            getCallsWaiting() {
                const epoch = this.callsWaitingEpoch;
                GetCallsWaiting().then((response) => {
                    // Failed requests still return Data, so check Error too — keep the current list instead of blanking the board
                    if (response?.Error || response?.Data == null) return;
                    // A queue push landed while this was in flight, so this snapshot is older than the list
                    if (epoch !== this.callsWaitingEpoch) return;
                    this.callsWaiting = response.Data.calls_waiting || [];
                    if (response?.Data?.live_dashboard_inbound_calls_enabled !== undefined) {
                        this.liveDashboardInboundCallsEnabled = response.Data.live_dashboard_inbound_calls_enabled;
                    }
                });
            },
            fetchOverviewTeamData(include) {
                if (!(this.scopedTeamId > 0)) {
                    this.scopedTeamAgents = null;
                    this.scopedTeamCallsWaiting = null;
                    this.scopedTeamDataLoading = false;
                    return;
                }

                const teamId = this.scopedTeamId;
                const options = { team_id: teamId };
                const loadAgents = !include || include === 'agents';
                const loadCalls = !include || include === 'calls';
                const showLoading = !include;

                if (showLoading) {
                    this.scopedTeamDataLoading = true;
                }

                let pending = (loadAgents ? 1 : 0) + (loadCalls ? 1 : 0);
                const finish = () => {
                    pending -= 1;
                    if (pending <= 0 && showLoading && teamId === this.scopedTeamId) {
                        this.scopedTeamDataLoading = false;
                    }
                };

                if (loadAgents) {
                    GetLiveDashboardAgents(options).then((response) => {
                        if (teamId !== this.scopedTeamId) {
                            return;
                        }
                        this.scopedTeamAgents = response?.Data?.agents || [];
                    }).finally(finish);
                }

                if (loadCalls) {
                    GetCallsWaiting(options).then((response) => {
                        if (teamId !== this.scopedTeamId || response?.Error || response?.Data == null) {
                            return;
                        }
                        this.scopedTeamCallsWaiting = response.Data.calls_waiting || [];
                        if (response?.Data?.live_dashboard_inbound_calls_enabled !== undefined) {
                            this.liveDashboardInboundCallsEnabled = response.Data.live_dashboard_inbound_calls_enabled;
                        }
                    }).finally(finish);
                }
            },
            getLiveDashboardAgents() {
                this.isLoading = true;
                GetLiveDashboardAgents().then((response) => {
                    if (response.Data?.agents?.length > 0) {
                        this.agents = response.Data.agents;
                    } else {
                        this.agents = [];
                    }

                    this.isLoading = false;
                });
            },
            getOrganizationUsers() {
                GetOrganizationUsers().then((response) => {
                    if (!!response.Data && !!response.Data.organization_users && response.Data.organization_users.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }
                });

                return;
            },
            getTeams() {

                const options = {
                    sort_by: 'teams_name_asc',
                }

                GetTeams(options).then((response) => {
                    if (response?.Data?.teams?.length > 0) {
                        this.teams = response.Data.teams;
                    }
                })
            },
            initFilterObj() {
                // const cookieValue = getCookie('v_dashboard_overview_filter');
                const cookieValue = getCookie('v_dashboard_agents_filter');
                const newFilterObj = cookieValue ? JSON.parse(cookieValue) : this.newFilterObj();

                this.filterObj = { ...newFilterObj };
                this.tmpFilterObj = { ...newFilterObj };
            },
            setFilterObj(filterObj) {
                this.filterObj = { ...filterObj };
                this.tmpFilterObj = { ...filterObj };
            },
            initDashboardSummary() {
                if (!this.sharedLinkMode) {
                    const options = {
                        is_minimum_only: false,
                        owner_id: (this.currentUser?.user_id || 0),
                        owner_type: "user",
                        time_zone_location: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
                    }
                    MatchOrCreateBaseDashboardSummary(options).then(() => {});
                } else {
                    const options = {
                        owner_id: (this.currentUser?.user_id || 0),
                        owner_type: "user",
                    };
                    GetCurrentBaseDashboardSummaryForSharedLink(options).then((response) => {
                        const payload = response?.Data?.data;
                        if (payload?.base_dashboard_summary?.id > 0) {
                            this.bus.send({ type: 'broadcast', channel: { Type: 'baseDashboardSummaryUpdates', ID: null }}, { Type: 'broadcast', Data: payload });
                        }
                    });
                }
            },
            newFilterObj() {
                return {
                    teamIds: [],
                }
            },
            pollBaseDashboardSummaries() {
                GetBaseDashboardSummaries().then((response) => {
                    // null Data means an error response — keep the current store state to
                    // avoid flashing "No data found" on a transient server-side failure
                    const summaries = response?.Data?.base_dashboard_summaries;
                    if (summaries == null) return;
                    VolieState.applyPolledBaseDashboardSummaries(summaries);
                });
            },
            startCallsWaitingPoll() {
                // Completion pushes only reach online agents in the call's queue, so TVs and supervisors
                // would otherwise keep showing calls that already ended until the page is reloaded.
                this.getCallsWaiting();
                this.callsWaitingPollInterval = setInterval(() => {
                    this.getCallsWaiting();
                    this.fetchOverviewTeamData('calls');
                }, 30000);
            },
            stopCallsWaitingPoll() {
                if (this.callsWaitingPollInterval) {
                    clearInterval(this.callsWaitingPollInterval);
                    this.callsWaitingPollInterval = null;
                }
            },
            startSummaryPoll() {
                // Poll for both session and shared-link viewers so TV/shared boards stay
                // current when realtime pushes are missed (parity with logged-in Live Dash).
                this.pollBaseDashboardSummaries();
                this.summaryPollInterval = setInterval(this.pollBaseDashboardSummaries, 30000);
            },
            stopSummaryPoll() {
                if (this.summaryPollInterval) {
                    clearInterval(this.summaryPollInterval);
                    this.summaryPollInterval = null;
                }
            },
            onCallCommunicationQueueUpdate(response) {


                // Verify legit call communication queue
                const ccq = response?.Data;
                if (!(ccq?.call_communication_queue_id > 0) || !(ccq?.account_id > 0) || !(ccq?.status?.length > 0)) {
                    return;
                }

                // Verify account matches is current user's account
                if (this.currentUser?.activated_account_id !== ccq.account_id) {
                    return;
                }

                this.callsWaitingEpoch++;

                // Determine if record is in array
                const idx = (this.callsWaiting || []).findIndex(i => i.call_communication_queue_id === ccq.call_communication_queue_id);
                if (idx >= 0) {

                    // If status is not waiting, remove from array
                    if (ccq.status !== "waiting" && ccq.status !== "ivr_callback") {
                        this.callsWaiting.splice(idx, 1);
                    }
                } else if (ccq.status === "waiting" || ccq.status === "ivr_callback") {

                    // If the status is waiting and it isn't currently in our array, add it
                    this.callsWaiting.push(ccq);

                    // Re-sort just in case
                    this.callsWaiting = this.sortCallsWaitingByID();
                }

                this.fetchOverviewTeamData('calls');
            },
            onLatestAgent(response) {

                // Note - the incoming agent record is made from the PushLatestAgentData struct, the page agents are LiveDashboardAgent

                // Verify legit agent
                const agent = response?.Data;
                if (!(agent?.user_id > 0) || !(agent?.account_id > 0) || !(agent?.account_user_id > 0)) {
                    return;
                }

                // Verify account matches is current user's account
                if (this.currentUser?.activated_account_id !== agent.account_id) {
                    return;
                }

                // Attempt to find existing agent. If we find it, just need to update fields
                const idx = (this.agents || []).findIndex(i => i.account_user_id === agent.account_user_id);
                if (idx >= 0) {

                    // Update fields on existing ref
                    const existingAgent = this.agents[idx];

                    // If the agent ID on the existing record is newer than the push, ignore
                    if (!(existingAgent?.account_user_id > 0) || existingAgent?.last_agent_id > agent.agent_id) {
                        return;
                    }

                    // console.debug(existingAgent.call_id, agent.call_id)

                    // Set fields
                    existingAgent.last_agent_id = agent.agent_id;
                    existingAgent.last_agent_status_id = agent.agent_status_id;
                    existingAgent.agent_created_at = agent.created_at;
                    existingAgent.agent_status_name = agent.agent_status_name;
                    existingAgent.agent_status_type = agent.status_type;
                    existingAgent.appointments_created_today = agent.appointments_created_today;
                    existingAgent.call_id = agent.call_id;
                    existingAgent.campaign_id = agent.campaign_id;
                    existingAgent.campaign_name = agent.campaign_name;
                    existingAgent.communication_type_name = agent.communication_type_name;
                    existingAgent.communication_provider_id = agent.communication_provider_id;
                    existingAgent.inbound_calls_today = agent.inbound_calls_today;
                    existingAgent.is_online = agent.is_online;
                    existingAgent.organization_id = agent.organization_id;
                    existingAgent.organization_name = agent.organization_name;
                    existingAgent.outbound_calls_today = agent.outbound_calls_today;
                    existingAgent.time_in_seconds = null;
                    existingAgent.total_calls = agent.total_calls;
                } else {

                    // Add record to array and resort
                    const liveDashboardAgent = this.pushLatestAgentDataToLiveDashboardAgent(agent);
                    if (!(liveDashboardAgent?.account_user_id > 0)) {
                        return;
                    }

                    this.agents.push(liveDashboardAgent);
                }

                this.fetchOverviewTeamData('agents');
            },
            onTodayAccountUserStats(response) {

                // Verify legit account user
                const accountUser = response?.Data;
                if (!(accountUser?.account_user_id > 0) || !(accountUser?.user_id > 0) || !(accountUser?.account_id > 0)) {
                    return;
                }

                // Find agent by account user ID
                const idx = (this.agents || []).findIndex(i => i.account_user_id === accountUser.account_user_id);
                if (idx < 0) {
                    return;
                }

                // Update fields on existing ref
                const existingAgent = this.agents[idx];
                if (!existingAgent) {
                    return;
                }

                // Set fields
                // existingAgent.inbound_calls_today = accountUser.inbound_calls_today;
                // existingAgent.outbound_calls_today = accountUser.outbound_calls_today;
                existingAgent.total_assigned_return_message_campaign_customers = accountUser.total_assigned_return_message_campaign_customers;
                // existingAgent.total_calls = accountUser.total_calls;
                existingAgent.unresponded_to_incoming_message_at = accountUser.unresponded_to_incoming_message_at;
                existingAgent.unresponded_to_incoming_message_id = accountUser.unresponded_to_incoming_message_id;
            },
            pushLatestAgentDataToLiveDashboardAgent(agent) {
                if (!agent) {
                    return;
                }

                return {
                    account_user_id: agent.account_user_id,
                    account_id: agent.account_id,
                    campaign_id: agent.campaign_id,
                    default_role_id: agent.default_role_id,
                    last_agent_id: agent.agent_id,
                    last_agent_status_id: agent.agent_status_id,
                    organization_id: agent.organization_id,
                    user_id: agent.user_id,
                    agent_created_at: agent.created_at,
                    agent_status_name: agent.agent_status_name,
                    agent_status_type: agent.status_type,
                    assigned_campaign_customer_actives: [],
                    campaign_name: agent.campaign_name,
                    communication_type_name: agent.communication_type_name,
                    inbound_calls_today: agent.inbound_calls_today,
                    is_online: agent.is_online,
                    organization_name: agent.organization_name,
                    outbound_calls_today: agent.outbound_calls_today,
                    role_name: agent.role_name,
                    time_in_seconds: null,
                    total_assigned_return_message_campaign_customers: agent.total_assigned_return_message_campaign_customers,
                    total_calls: agent.total_calls,
                    unresponded_to_incoming_message_at: null,
                    unresponded_to_incoming_message_id: agent.unresponded_to_incoming_message_id,
                    unresponded_to_time_in_seconds: null,
                    user_email: agent.email,
                    user_full_name: agent.full_name,
                }
            },
            resetFilter() {
                this.filterObj = this.newFilterObj();
                this.tmpFilterObj = this.newFilterObj();
                this.filterDialog = false;
            },
            setClockValues() {

                // Check if we have calls waiting
                if (this.callsWaiting?.length > 0) {

                    // Init
                    const currentTime = new Date();

                    // Loop through calls and set time in seconds
                    for (let i = 0; i < this.callsWaiting.length; i++) {

                        // Init agent
                        const ccq = this.callsWaiting[i];
                        if (!ccq || !ccq.start_time) {
                            continue;
                        }

                        // Init agent time
                        const ccqTime = new Date(ccq.start_time);

                        // Calculate clock
                        ccq.hold_time_in_seconds = (Math.floor(currentTime.getTime() - ccqTime.getTime()) / 1000);
                    }
                }

                // Dashboard summary data is frozen to prevent Vue reactive overhead.
                // Waiting durations are computed locally in waiting.vue from timestamps.
            },
            setHtmlOverflow(value) {
                //next tick it so the overflow gets set correctly
                Vue.nextTick(() => {
                    const htmlTag = document.getElementsByTagName('html')[0];
                    if (!!htmlTag) {

                        // remove tags
                        htmlTag.classList.remove('overflow-y-hidden');
                        htmlTag.classList.remove('overflow-y-scroll');

                        // If hidden, need to scroll back to top
                        if (value === "hidden") {
                            window.scrollTo(0, 0);
                            htmlTag.classList.add('overflow-y-hidden');

                        } else if(value === "scroll"){
                            htmlTag.classList.add('overflow-y-scroll');
                        }
                    }
                });
            },
            setSupervisorRole(role) {
                if (role == "barge") {
                    this.isBarge = true;
                } else if (role == "listen") {
                    this.isListen = true;
                } else if (role == "coach") {
                    this.isCoach = true;
                } else {
                    this.isLiveDashInboundCall = true;
                }
            },
            setCurrentCall(supervisorCall) {
                if ((!supervisorCall) || !(supervisorCall?.call?.id > 0)) {
                    return;
                }

                this.currentCall = supervisorCall;
            },
            setCurrentCampaignCustomer(currentCampaignCustomer) {
                if (!currentCampaignCustomer || !(currentCampaignCustomer?.campaign_customer_active_id > 0)) {
                    return;
                }

                this.currentCampaignCustomer = currentCampaignCustomer;
            },
            setAsCallWithoutCustomer() {
                this.isCallWithoutCustomer = true;
            },
            setCurrentWebRtcParticipant(currentWebRtcParticipant) {
                if (!currentWebRtcParticipant || !(currentWebRtcParticipant?.id > 0)) {
                    return;
                }
                this.currentWebRtcParticipant = currentWebRtcParticipant;
            },
            setCurrentWebRtcSession(currentWebRtcSession) {
                if (!currentWebRtcSession || !(currentWebRtcSession?.id > 0)) {
                    return;
                }

                this.currentWebRtcSession = currentWebRtcSession;
            },
            sortCallsWaitingByID() {
                if (!(this.callsWaiting?.length > 0)) {
                    return [];
                }

                return this.callsWaiting.slice(0).sort(function(x, y){
                    return x?.call_communication_queue_id - y?.call_communication_queue_id;
                });
            },
            splitGoalsByRecurringType(goals) {
                const goalsByType = goals.reduce((accumulator, goal) => {
                    const { recurring_type } = goal;

                    if (!accumulator[recurring_type]) {
                        accumulator[recurring_type] = [];
                    }

                    accumulator[recurring_type].push(goal);
                    return accumulator;
                }, {});

                const recurringTypeOrder = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'];
                const orderedGoals = {};
                recurringTypeOrder.forEach(type => {
                    if (goalsByType[type]) {
                        orderedGoals[type] = goalsByType[type];
                    }
                });

                return orderedGoals;
            },
            startClock() {
                this.clockInterval = setInterval(this.setClockValues, 1000);
            },
            stopClock() {
                if (!this.clockInterval) {
                    return;
                }

                clearInterval(this.clockInterval);
            },
            submitFilter() {
                this.filterObj = { ...this.tmpFilterObj };

                if (this.tmpFilterObj.makeDefaultFilter) {
                    // If no teams are selected, just pass empty teams (avoids the checkbox defaulting to true from cookie when it shouldn't)
                    const newCookieVal = (this.filterObj.teamIds?.length > 0) ? { ...this.filterObj } : { teamIds: [] };
                    setCookie('v_dashboard_overview_filter', JSON.stringify(newCookieVal));
                }

                this.filterDialog = false;
            },
        },
        computed: {
            dashboardSummaryConversationGroups() {
                return this.currentBaseDashboardSummary?.data?.dashboard_summary_conversation_groups || [];
            },
            currentBaseDashboardSummary() {
                if (this.scopedTeamId > 0) {
                    return VolieState.baseDashboardSummaries().find(i => i.base_dashboard_summary?.owner_type === "team" && i.base_dashboard_summary?.owner_id === this.scopedTeamId);
                }

                return VolieState.currentBaseDashboardSummary();
            },
            currentDashboardSummary() {
                return this.currentBaseDashboardSummary?.data?.dashboard_summary;
            },
            currentDayDashboardSummary() {

                // Verify (this could be null during initial load)
                if (!this.validBaseDashboardSummary) {
                    return {};
                }

                // Loop over day summaries and grab day summary (will only be one)
                for (let i = 0; i < this.currentBaseDashboardSummary.data.dashboard_summary_periods.length; i++) {

                    // Init
                    const child = this.currentBaseDashboardSummary.data.dashboard_summary_periods[i];
                    if (!child || !(child.id > 0)) {
                        continue;
                    }

                    // Check for day
                    if (child.period_type !== "day") {
                        continue;
                    }

                    return child;
                }

                return {};
            },
            hourlyDashboardSummaries() {
                return this.currentBaseDashboardSummary?.data?.dashboard_summary_periods?.filter(i => i.period_type === "hour") || [];
            },
            // this is for v message
            currentNavigation() {
                return this.currentTab === 'vmessage-tab' ? 'v_message' : this.currentTab;
            },
            currentUser() {
                return VolieState.currentUser();
            },
            paddingTopClass() {
                return this.currentTab === 'vmessage-tab' ? null : 'pt-md-2';
            },
            validBaseDashboardSummary() {
                return this.currentBaseDashboardSummary?.base_dashboard_summary?.id > 0 && (this.scopedTeamId > 0 || this.sharedLinkMode || this.currentBaseDashboardSummary?.base_dashboard_summary?.owner_id === this.currentUser?.user_id) && this.currentBaseDashboardSummary?.data?.dashboard_summary?.id > 0 && this.currentBaseDashboardSummary?.data?.dashboard_summary_periods?.length > 0;
            },
            validCurrentCampaignCustomer() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
            teamScopeEmptyMessage() {
                if (!(this.scopedTeamId > 0) || this.validBaseDashboardSummary) {
                    return null;
                }

                if (!(this.currentBaseDashboardSummary?.base_dashboard_summary?.id > 0)) {
                    return 'No dashboard for this team.';
                }

                return 'No results for this team yet.';
            },
        },
        components: {
            AgentsTab,
            CallsTab,
            CurrentCampaignCustomer,
            Goals,
            MessageDashboardTab,
            MessageScreenTab,
            OverviewTab,
            SharedLinksDialog,
            VMessage,
        },
        props: {
            accountId: Number,
            sharedLinkMode: Boolean,
        },
        watch: {
            currentTab(newVal) {
                if (newVal === 'overview-tab') {
                    this.scopedTeamId = null;
                }
            },
            scopedTeamId() {
                this.fetchOverviewTeamData();
            },
        },
        destroyed() {
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "agent" }}, this.onLatestAgent);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "todayAccountUserStats" }}, this.onTodayAccountUserStats);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "callCommunicationQueueUpdate" }}, this.onCallCommunicationQueueUpdate);
            this.stopCallsWaitingPoll();
            this.stopClock();
            this.stopSummaryPoll();
        },
        created() {
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "agent" }}, this.onLatestAgent);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "todayAccountUserStats" }}, this.onTodayAccountUserStats);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "callCommunicationQueueUpdate" }}, this.onCallCommunicationQueueUpdate);
            this.initFilterObj();
            this.getLiveDashboardAgents();
            this.getTeams();
            this.initDashboardSummary();
            this.startCallsWaitingPoll();
            this.startClock();
            this.startSummaryPoll();
            if (!this.sharedLinkMode) {
                this.getAccountGoalsForToday();
            }
        },
    });
</script>

<style lang="scss" scoped>
</style>
